<template>
    <div class="addHeathly-container">
        <div class="addForm-container">
            <div class="input-textarea">
                <van-field
                    v-model="recordValue"
                    rows="6"
                    autosize
                    class="textarea"
                    type="textarea"
                    :placeholder="$t('patient.pleaseRecordContent')"
                    />
            </div>
            <div class="imgUpload">
                <p class="title">
                    记录资料
                </p>
                <div class="heathly-info">
                    <div class="info-item" v-for="(item, index) in uploadimg" :key="index" @click="seePerview(item)">
                        <img :src="item.img" class="upload-img" alt="" >
                        <img src="@/assets/images/video-play-icon.png" v-if="item.type == 'video'" class="web__msg--video-play" />
                        <van-icon name="cross" @click.stop="uploadimg.splice(index, 1)" />
                    </div>
                    <div class="info-item upload-file" @click="uploadClick" v-if="uploadimg.length<9">
                        <input type="file" ref="files" @click.stop :accept="uploadAccept " @change="uploadChange">
                        <video id="videoPeiview" @click.stop preload="auto" style="opacity: 0;position: absolute;z-index: -11;" src=""></video>
                         
                        <van-icon name="plus" />
                    </div>
                </div>
                <!-- <van-uploader class="heathly" accept="image/*,video/*" v-model="uploadimg" :multiple="true" :max-count="100">
                    <div class="uploadbox">
                        <i class="icon"></i>
                        <p class="txt">{{$t("patient.uploadtxt")}}</p>
                    </div>
                </van-uploader> -->
            </div>
        </div>
        <div class="submit-btn" @click="submitFun">
            {{$t("patient.submit")}}
        </div>
        <canvas id="canvasTwo"></canvas>
        <van-popup v-model="videoShow"  get-container="body" class="videoPopup">
            <img src="@/assets/images/warning.png" class="close" @click="videoShow = false">
            <div  class="video-box" v-if="videoUrl">
                <video  ref="video" id="video" v-if="videoShow"  controls="controls" @focus="clickVideo($event)" :poster="videoPoster">
                    <source :src="videoUrl" type="video/mp4">
                    <!-- <source :src="msgWrapper.msg.msgBody.content.url" type="video/webm">
                    <source :src="msgWrapper.msg.msgBody.content.url" type="video/ogg"> -->
                    {{$t('im.noVideo')}}
                </video>
            </div>
        </van-popup>
        <van-action-sheet
            v-model="uploadActionShow"
            :actions="actions"
            cancel-text="取消"
            close-on-click-action
            @select="onSelect" 
            />
    </div>
</template>

<script>
import { ImagePreview } from 'vant'
import { debounce } from "@/utils/vaildate"
import { tracehealthyUpdate, tracehealthyGet, tracehealthyAdd } from "@/api/patient"
import { getLocalTime } from "@/utils/date"
export default {
    data () {
        return {
            recordValue:"",
            uploadimg:[],
            videoShow:false,
            videoUrl:"",
            uploadAccept:null,
            videoPoster:"",
            uploadActionShow:false,
            actions: [{ name: '图片',type:114001 }, { name: '视频' ,type:114003}],
            heathlyId:this.$route.query.heathlyId,
            patientId:this.$route.query.patientId,
        }
    },
    created () {
        document.title = this.$t("patient.addHeathlyRecord");
        if(this.$route.query.heathlyId){
            document.title = this.$t("patient.editRecord");
            this.gethealthyData()
        }

    },
    methods: {
        gethealthyData(){
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            tracehealthyGet({
                patientId:this.patientId,
                id:this.heathlyId
            }).then(result =>{
                console.log(result);
                toast.clear();
                if(result.data.errorCode == 0){
                    this.recordValue = result.data.data.log;
                    this.uploadimg = []
                    for (let i = 0; i < result.data.data.traceMediaItems.length; i++) {
                        const it = result.data.data.traceMediaItems[i];
                        let imgOrVideoData = JSON.parse(it.data);
                        this.uploadimg.push({
                            img:it.type == 114001?imgOrVideoData.big.url:imgOrVideoData.bigImg.url,
                            imgOrVideoData:it,
                            base64:it.type == 114001?imgOrVideoData.big.url:imgOrVideoData.url,
                            type:it.type == 114001?'image':'video',
                            
                        });
                    }
                }
            })
        },
        async submitFun(){
            if(!this.recordValue){
                this.$toast(this.$t("patient.pleaseRecordContent"));
                return false;
            }
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            let arr = [];
            for (let i = 0; i < this.uploadimg.length; i++) {
                const it = this.uploadimg[i];
                if(it.img.indexOf("base64,") > -1){
                    let url = await this.uploadFile(it);
                    if(url){
                        arr.push(url);
                    }
                }else{
                    arr.push(it.imgOrVideoData)
                }
            }
            let time = getLocalTime(new Date());
            let datadd = {
                patientId:this.patientId,
                traceDt:time.replace(/\//g,'-'),
                log:this.recordValue,
                traceMediaItems:arr,
                imgUrls:[]
            }
            if(!this.heathlyId){
                tracehealthyAdd(datadd).then(result =>{
                    toast.clear()
                    if(result.data.errorCode == 0){
                        this.$router.go(-1);
                    }else{
                        this.$toast(result.data.errorMsg);
                    }
                })
            }else{
                datadd.id  = this.heathlyId;
                tracehealthyUpdate(datadd).then(result=>{
                    toast.clear()
                    if(result.data.errorCode == 0){
                        this.$router.go(-1);
                    }else{
                        this.$toast(result.data.errorMsg);
                    }
                })
            }

            // imgUrls
        },
        async uploadFile(file){
            let uploadResData;
            if(file.type == 'image'){
                uploadResData = await this.$uploadAxios.post(
                    '/upload/im/image/base64-upload',
                    {
                        data: file.base64,
                        fileName: file.name
                    }
                )
                if(uploadResData.errorCode == 0){
                    return {data:JSON.stringify(uploadResData.data),type:114001};
                }else{
                    return null;
                }
            }else{
                uploadResData = await this.$uploadAxios.post(
                    '/upload/im/video/base64-upload',
                    {
                        data: file.base64,
                        fileName: file.name
                    }
                )
                if(uploadResData.errorCode == 0){
                    return {data:JSON.stringify(uploadResData.data),type:114003};
                }else{
                    return null;
                }
            }
        },
        uploadClick(){
            this.uploadActionShow = true;
        },
        onSelect(e){
            console.log(e);
            if(e.type == 114001){
                this.uploadAccept = 'image/*';
            }else{
                this.uploadAccept = 'video/*';
            }
            setTimeout(() => {
                this.$refs.files.click();
            }, 10);
        },
        uploadChange(e){
            let that = this;
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            let file = e.target.files[0];
            if(file.type.indexOf("video/")>-1){
                let dataURL = '';
                        
                let reader = new FileReader();
                // 异步读取文件内容，结果用data:url的字符串形式表示
                reader.readAsDataURL(file);
                /*当读取操作成功完成时调用*/
                reader.onload = function (base) {
                    // 创建视频对象\
                    
                    let video = document.getElementById("videoPeiview");
                    // let video = document.createElement("video");1
                    video.width = 200;
                    video.height = 500;
                    video.setAttribute('crossOrigin', 'Anonymous');
                    video.setAttribute('controls', 'controls');
                    video.setAttribute('autoplay', 'true');
                    video.volume = 0;
                    video.setAttribute('src', base.target.result); // 视频的链接
                    // video.play();
                    // video.click()
                    video.addEventListener('loadeddata',renderCanvas)
                    function renderCanvas(){
                         toast.clear()
                        // 创建canvas画布
                        let canvas = document.createElement('canvas');
                        // let canvas = document.getElementById('canvasTwo');
                        let videoTwo =  document.getElementById("videoPeiview");
                        canvas.width = video.width;  // 设置画布的长宽也就是图片的长宽
                        canvas.height = video.height;
                        // console.log(video.);
                        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

                        that.uploadimg.push({
                            base64:base.target.result,
                            type:'video',
                            name:file.name,
                            img:canvas.toDataURL('image/png')
                        })
                        video.removeEventListener('loadeddata',renderCanvas, false);

                    }
                }
            }else{
                 let reader = new FileReader();
                // 异步读取文件内容，结果用data:url的字符串形式表示
                reader.readAsDataURL(file);
                /*当读取操作成功完成时调用*/
                reader.onload = function (e) {
                    toast.clear()
                    that.uploadimg.push({
                        base64:e.target.result,
                        type:'image',
                        name:file.name,
                        img:e.target.result
                    })
                }
            }
            e.target.value = null;
        },
        seePerview(item){
            if(item.type == "image"){
                ImagePreview([item.img]);
            }else if(item.type == "video"){
                this.videoUrl = item.base64;
                this.videoShow = true;
                setTimeout(()=>{
                    // console.log(this.$refs.video);
                    this.$refs.video.play();
                    // window.scrollBy(0,1);
                    // window.location.href = this.msgWrapper.msg.msgBody.content.url
                },500)
            }
        },
        getFileURL (file) {
            let getUrl = null
            if (window.createObjectURL !== undefined) {
                getUrl = window.createObjectURL(file)
            } else if (window.URL !== undefined) {
                // window.URL 标准定义
                // mozilla(firefox)
                // 获取一个http格式的url路径，这个时候就可以设置<img>中的显示
                getUrl = window.URL.createObjectURL(file)
            } else if (window.webkitURL !== undefined) {
                getUrl = window.webkitURL.createObjectURL(file)
            }
            return getUrl
        }
    }

}
</script>

<style lang="less" scoped>
.addHeathly-container{
    min-height: 100vh;
    background: #f5f5f5;
    height: max-content;
    .addForm-container{
        background: #fff;
        padding: 0.6rem;
        /deep/ .input-textarea .textarea{
            font-size: 0.6rem;
            line-height: 0.7rem;
            padding: 0;
        }
        .imgUpload{
            .title{
                margin: 0.2rem 0;
                font-size: 0.64rem;
            }
            .heathly-info{
                display: flex;
                flex-wrap: wrap;
                .info-item{
                    width: 4.4rem;
                    height: 4.4rem;
                    margin: 0 0.2rem 0.2rem 0;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    img{
                        max-width: 100%;
                        max-height: 100%;
                        height: auto;
                        width: auto;
                    }
                    .upload-img{
                        height: auto;
                        width: auto;
                        position: absolute;
                        max-width: 300%;
                        max-height: 300%;
                        min-width: 80%;
                        min-height: 80%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }

                    .van-icon-cross {
                        position: absolute;
                        top: 0;
                        right: 0;
                        font-size: 0.4rem;
                        padding: 0.1rem;
                        color: #fff;
                        background: rgba(0, 0, 0, 0.3);
                    }
                    .web__msg--video-play{
                        width: 0.86rem;
                        height: 0.86rem;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        margin: auto;
                        background-size: cover;
                        position: absolute;
                    }
                }
                .upload-file{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #f3f3f3;
                    border-radius: 0.1rem;
                    input{
                        display: none;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                    }
                    .van-icon-plus{
                        color: #e1e1e1;
                        font-size: 2rem;
                        font-weight: bold;                        
                    }
                }
            }
        }
    }
    .submit-btn{
        width: 11.6rem;
        height: 1.6rem;
        margin: 1.5rem auto;
        background: #3da6fe;
        border-radius: 0.8rem;
        text-align: center;
        line-height: 1.6rem;
        color: #fff;
        font-size: 0.64rem;
    }
}
.videoPopup{
  width: 90%;
  height: 95%;
  margin: 0 auto;
  background: none;
  img{
    width: 1.25rem;
    height: 1.25rem;
    right: 0;
    top: 0;
    z-index: 9;
    position: absolute;
  }
  .video-box{
    width: 100%;
    height: 100%;
    // margin-top: 1.5rem;
    video{
      height: 100%;
      width: 100%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>